import CityPageTemplate from './CityPageTemplate';

const cityData = {
  cityName: "Cottage Grove",
  metaDescription: "Reliable plumber in Cottage Grove, MN. Bruce Nelson Plumbing & Heating provides residential and commercial plumbing services. Call 651-738-9354.",
  heroTitle: "Plumber in Cottage Grove, MN",
  heroSubtitle: "Quality plumbing services for Cottage Grove families and businesses.",
  introduction: "Cottage Grove residents trust Bruce Nelson Plumbing & Heating for dependable plumbing services. Located along the scenic Mississippi River, Cottage Grove homes require plumbers who understand the area's unique needs. Whether you're near Kingston Village or the Grove area, our experienced technicians provide prompt, professional service.",
  services: [
    {
      title: "Residential Plumbing",
      description: "Complete plumbing solutions for Cottage Grove homes.",
      link: "/services/residential"
    },
    {
      title: "Commercial Plumbing",
      description: "Professional plumbing services for Cottage Grove businesses.",
      link: "/services/commercial"
    },
    {
      title: "Boiler Service",
      description: "Expert boiler repair and maintenance for Cottage Grove properties.",
      link: "/services/boilers"
    },
    {
      title: "Water Heater Repair",
      description: "Fast water heater service throughout Cottage Grove.",
      link: "/services/water-heaters"
    },
    {
      title: "Remodeling Services",
      description: "Kitchen and bathroom plumbing remodeling for Cottage Grove homes.",
      link: "/services/remodeling"
    },
    {
      title: "Drain Cleaning",
      description: "Professional drain cleaning for Cottage Grove residents.",
      link: "/services"
    }
  ],
  whyChooseUs: [
    "Serving Cottage Grove and the east metro since 1976",
    "Licensed, bonded, and insured professionals",
    "Experience with Cottage Grove's diverse housing",
    "Upfront, honest pricing",
    "Fast response times to Cottage Grove",
    "Highly rated by local homeowners"
  ],
  serviceAreas: [
    { name: "Woodbury", link: "/plumber-woodbury" },
    { name: "Saint Paul", link: "/plumber-saint-paul" },
    { name: "Oakdale", link: "/plumber-oakdale" },
    { name: "Newport", link: "/plumber-newport" },
    { name: "Maplewood", link: "/plumber-maplewood" },
    { name: "Lake Elmo", link: "/plumber-lake-elmo" }
  ],
  testimonial: {
    text: "Great experience with BNPH! They fixed our plumbing issue quickly and the price was very fair. Will definitely use them again.",
    author: "Chris H."
  }
};

const CottageGrovePage = () => <CityPageTemplate cityData={cityData} />;

export default CottageGrovePage;
